import { createAction, createReducer } from '@reduxjs/toolkit';

import { GroundStationManager, Loadable, WebSocketManager } from 'models';
import { makeThunkFromAPICall } from 'state';

export type GroundStationsState = {
    list: Loadable<GroundStationManager.GroundStation[]>;
    commandTypes: Loadable<GroundStationManager.CommandType[]>;
    latestCommands: Record<number, GroundStationManager.API.Command>;
};

const initialState: GroundStationsState = {
    list: { status: 'idle' },
    commandTypes: { status: 'idle' },
    latestCommands: {},
};

export const [getGroundStationList, setGroundStationList] =
    makeThunkFromAPICall(
        GroundStationManager.listGroundStations,
        'groundstations/list',
    );

export const [getGroundStationCommandTypes, setGroundStationCommandTypes] =
    makeThunkFromAPICall(
        GroundStationManager.listGroundStationCommandTypes,
        'groundstations/commandtypes/list',
    );

export const [getGroundStationCZML, setGroundStationCZML] =
    makeThunkFromAPICall(
        GroundStationManager.getGroundStationCZML,
        'groundstations/czml',
    );

export const [sendGroundStationCommand, setGroundStationCommandResults] =
    makeThunkFromAPICall(
        GroundStationManager.sendCommand,
        'groundstations/command',
    );

export const setGroundStationCommandLastUpdated =
    createAction<WebSocketManager.GroundStationCommandUpdate>(
        'groundstations/command-updated',
    );

export const groundstationsReducer = createReducer(initialState, (builder) => {
    builder.addCase(setGroundStationList, (state, action) => {
        return {
            ...state,
            list: { ...state.list, ...action.payload.loadable },
        };
    });

    builder.addCase(setGroundStationCommandTypes, (state, action) => {
        return {
            ...state,
            commandTypes: { ...state.commandTypes, ...action.payload.loadable },
        };
    });

    builder.addCase(setGroundStationCommandLastUpdated, (state, action) => {
        return {
            ...state,
            latestCommands: {
                ...state.latestCommands,
                [action.payload.data.id]: action.payload.data,
            },
        };
    });
});

export const groundstationsActions = {
    getGroundStationList,
    setGroundStationList,
    getGroundStationCZML,
    sendGroundStationCommand,
    getGroundStationCommandTypes,
    setGroundStationCommandLastUpdated,
};

export default groundstationsReducer;
